module.exports = "/_next/static/images/c950deb8126213b74cfdf40b7cce13fd-2-women-working-landscape@0.75x.jpg";